// extracted by mini-css-extract-plugin
module.exports = {"pic":"onlineRenew_pic_I5Xik","wrapper":"onlineRenew_wrapper_2aIVF"};